import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

// Credentials from env.mobile
const poolData = {
  UserPoolId: "us-east-1_zg2PonfzH",
  ClientId: "3sofj4d1se9f65kj8pjt48csf7", // Using the web client ID
};

const userPool = new CognitoUserPool(poolData);

export interface SignInResult {
  type: "SUCCESS" | "NEW_PASSWORD_REQUIRED";
  session?: any;
  cognitoUser?: CognitoUser;
  userAttributes?: Record<string, string>;
}

export const signIn = (username: string, password: string): Promise<SignInResult> => {
  return new Promise((resolve, reject) => {
    const authenticationData = {
      Username: username,
      Password: password,
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);

    const userData = {
      Username: username,
      Pool: userPool,
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        resolve({ type: "SUCCESS", session: result });
      },
      onFailure: (err) => {
        reject(err);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // Remove all non-writable attributes that Cognito returns
        // Only keep attributes that are in requiredAttributes
        delete userAttributes.email_verified;
        delete userAttributes.phone_number_verified;
        delete userAttributes.email;
        delete userAttributes.phone_number;
        delete userAttributes.sub;

        // Only pass back the required attributes
        const cleanAttributes: Record<string, string> = {};
        for (const attr of requiredAttributes) {
          if (userAttributes[attr]) {
            cleanAttributes[attr] = userAttributes[attr];
          }
        }

        resolve({
          type: "NEW_PASSWORD_REQUIRED",
          cognitoUser,
          userAttributes: cleanAttributes,
        });
      },
    });
  });
};

export const completeNewPassword = (
  cognitoUser: CognitoUser,
  newPassword: string,
  userAttributes: Record<string, string> = {}
): Promise<any> => {
  return new Promise((resolve, reject) => {
    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: (result) => {
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
};
